<template>
  <el-upload
    v-if="isImportExportEnabled"
    class="upload-btn"
    ref="upload"
    action="#"
    :accept="accepts"
    :limit="1"
    :http-request="handleUpload"
    :show-file-list="false"
  >
    <i class="xp-icon-download" />
    {{ $t('CampaignForm_Button_ImportContent') }}
  </el-upload>
</template>

<script>
import { fields as importFields } from '@/modules/campaign-manage/enum/ImportExportFields'
import _ from 'lodash'
import { customConfirm, projectEndpoint } from '@/core/helpers'
import { $hasFeature } from '@/core/utils/VueAcl'
import { channelTypes } from '@/modules/campaign-manage/enum/Labels'
import RestApi from '@/core/services/RestApi'
import { onsiteTypes } from '@/modules/campaign-manage/enum/OnsiteTypesEnum'
export default {
  name: 'ImportContentButton',
  props: {
    channel: {
      type: Number,
      required: true
    },
    value: {
      type: Object,
      required: true
    },
    type: {
      type: [Number, String],
      required: false,
      default: 'default'
    },
    accepts: {
      required: false,
      type: String,
      default: '.json'
    },
    showWarning: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      importFields
    }
  },
  computed: {
    isImportExportEnabled() {
      return $hasFeature('contentImportExport')
    }
  },
  methods: {
    setEmailHtml(json) {
      this.loading = true
      RestApi(
        projectEndpoint({
          method: 'post',
          url: `bee-api/html`,
          data: { json: json.page }
        })
      )
        .then(({ data }) => {
          this.value.email_html = data.html
        })
        .catch(error => {
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleUpload(data) {
      const reader = new FileReader()

      reader.onload = () => {
        try {
          const json = JSON.parse(reader.result)
          if (this.showWarning) {
            customConfirm(
              this.$t('CampaignForm_ImportContentButton_Confirm_Title'),
              this.$t('CampaignForm_ImportContentButton_Confirm_Message'),
              this.$t('CampaignForm_ImportContentButton_Confirm_Btn_Confirm')
            ).then(() => {
              this.setUploadedData(json)
            })
          } else {
            this.setUploadedData(json)
          }
        } catch (e) {
          this.$message({
            message: `${e.name}: ${e.message}`,
            type: 'error'
          })
        }
      }

      reader.readAsText(data.file)
      this.$refs.upload.clearFiles()
    },
    setUploadedData(data) {
      // unwrap channels from channel specific key (exclude channels that are meant to be wrapped: inapp, onsite popup)
      if (this.value.onsite_type === onsiteTypes.ALERT) {
        data = _.get(data, 'onsite.alert')
      } else if (
        this.channel !== channelTypes.onsite &&
        this.channel !== channelTypes.inapp
      ) {
        data = data[this.$route.query.channel]
      }

      let fields = _.get(this.importFields, `${this.channel}.${this.type}`, [])
      fields.forEach(field => {
        let value = _.get(data, field, '')
        if (this.channel === channelTypes.email && field === 'email_template') {
          this.setEmailHtml(value)
          _.set(this.value, field, JSON.stringify(value))
        } else if (this.channel === channelTypes.onsite && onsiteTypes.POPUP) {
          this.setPopupProps(field, value)
        } else {
          _.set(this.value, field, value)
        }
      })
    },
    setPopupProps(field, value) {
      if (field === 'onsite.popup.button0.text') {
        this.value.onsite.popup.button0.enabled = Number(!!value)
      }
      if (field === 'onsite.popup.button1.text') {
        this.value.onsite.popup.button1.enabled = Number(!!value)
      }
      if (field === 'onsite.popup.title') {
        this.value.onsite.popup.title_checkbox = Number(!!value)
      }
      if (field === 'onsite.popup.main_text') {
        this.value.onsite.popup.text_checkbox = Number(!!value)
      }
      if (field === 'onsite.popup.footer') {
        this.value.onsite.popup.footer_checkbox = Number(!!value)
      }

      _.set(this.value, field, value)
    }
  }
}
</script>

<style scoped lang="scss">
.upload-btn {
  display: inline;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/ImportContentButton.vue